export const genareteColor = (str) => {
  return (
    (str === "Applied" && "BlueWhite") ||
    (str === "Contacted" && "BlueWhite") ||
    (str === "Pending" && "LightBlueWhite") ||
    (str == 0 && "LightBlueWhite") ||
    ((str === "Approved" || str === "Employee") && "GreenWhite") ||
    (str === "Release" && "GreenWhite") ||
    (str === "Completed" && "GreenWhite") ||
    (str === "Active" && "GreenWhite") ||
    (str === "Accepted" && "GreenWhite") ||
    (str == 1 && "BlueWhite") ||
    (str == "Submitted" && "BlueWhite") ||
    (str == 2 && "GreenWhite") ||
    (str === "Rejected" && "OrangeWhite") ||
    (str === "Blocked" && "OrangeWhite") ||
    (str === "Reviewed" && str === "Review" && "BlueGreen") ||
    (str==="View & Apply" && "btnsAudit") ||
    "OrangeWhite"
  );
};
